/**
 * Cross-browser timeout signal for fetch requests.
 *
 * AbortSignal.timeout() is not available in Safari < 16 (iOS Chrome
 * uses WebKit, so it's affected too). This utility provides the same
 * behavior using AbortController + setTimeout, which works everywhere.
 */
export function createTimeoutSignal(ms: number): AbortSignal {
  const controller = new AbortController();
  setTimeout(() => controller.abort(), ms);
  return controller.signal;
}
